import { Button } from '@/components/buttons/button';
import { cn } from '@/lib/utils';
import { MouseEventHandler } from 'react';

interface TrialContinueButtonProps {
    onClick: MouseEventHandler;
    className?: string;
    title: string;
    buttonClassName?: string;
    disabled?: boolean;
    showDesc?: boolean;

}

export function TrialContinueButton({ onClick, className, title, buttonClassName, disabled, showDesc }: TrialContinueButtonProps) {
    return (
        <div>
            <div className={cn('flex justify-center items-center', className)}>
                <Button
                    className={cn("px-5 bg-light-green/01 rounded-md text-black text-sm font-medium leading-normal tracking-normal hover:opacity-90 hover:brightness-110 hover:bg-light-green/01 focus:opacity-90 focus:brightness-110 focus-visible:ring-0 focus-visible:ring-offset-0 transition-all duration-300", buttonClassName)}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {title}
                </Button>
            </div>
            {showDesc && <p className='mt-2 text-gray-500 text-sm font-medium leading-relaxed tracking-normal text-center'>
                No credit card needed
            </p>}
        </div>
    );
}
